module.exports = __webpack_public_path__ + "img/Boy_030003.6968fda1.png";